"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7239],{

/***/ 47239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AppLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./components/base-layout.js
var base_layout = __webpack_require__(14774);
// EXTERNAL MODULE: ./components/footer/index.js
var footer = __webpack_require__(23333);
// EXTERNAL MODULE: ./components/head.js
var head = __webpack_require__(55480);
// EXTERNAL MODULE: ./components/member/containers/search.js
var containers_search = __webpack_require__(19789);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(63153);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/listeners.js
var listeners = __webpack_require__(90403);
;// CONCATENATED MODULE: ./lib/useEventListener.js

var useEventListener = function() {
    var event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", action = arguments.length > 1 ? arguments[1] : void 0, props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], bubble = arguments.length > 3 ? arguments[3] : void 0;
    (0,react.useEffect)(function() {
        if (false) {}
        document.addEventListener(event, action, bubble);
        return function() {
            return document.removeEventListener(event, action, bubble);
        };
    }, props);
};

;// CONCATENATED MODULE: ./lib/useKeyDown.js

var useKeyDown = function(keyCode, action, props) {
    useEventListener("keydown", function(e) {
        return e.keyCode === keyCode && action(e, props);
    }, props);
};

// EXTERNAL MODULE: ./hooks/useCurrentUser.js
var useCurrentUser = __webpack_require__(73038);
// EXTERNAL MODULE: ./components/avatar/index.tsx + 1 modules
var avatar = __webpack_require__(11304);
;// CONCATENATED MODULE: ./components/member/search.js











var SearchPopover = function() {
    var isAdmin = (0,useCurrentUser/* useCurrentUser */.x)().isAdmin;
    var ref = (0,containers_search/* useMemberSearchContainer */.c)(), open = ref.open, setOpen = ref.setOpen, search = ref.search, setSearch = ref.setSearch, data = ref.data, isLoading = ref.isLoading;
    var push = (0,router.useRouter)().push;
    var onHandleChange = function(param) {
        var id = param.id;
        setOpen(false);
        setSearch("");
        push("/member/".concat(id));
    };
    // cmd + K
    useKeyDown(75, function(e) {
        if (e.metaKey) {
            setOpen(true);
        }
    }, []);
    //escape
    (0,listeners/* useEscapeKey */.qX)(function() {
        setSearch("");
        setOpen(false);
    });
    if (!isAdmin) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative inline-block text-left",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Root */.uT.Root, {
            show: open,
            as: react.Fragment,
            afterLeave: function() {
                return setSearch("");
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(headlessui_esm/* Dialog */.Vq, {
                as: "div",
                className: "fixed inset-0 z-50 overflow-y-auto p-4 sm:p-6 md:p-20",
                onClose: setOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Dialog.Overlay */.Vq.Overlay, {
                            className: "fixed inset-0 bg-neutral-700 backdrop-blur backdrop-filter bg-opacity-25 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(headlessui_esm/* Combobox */.hQ, {
                            as: "div",
                            className: "mx-auto max-w-xl transform divide-y divide-neutral-800 border border-neutral-700/60 overflow-hidden rounded-xl bg-black backdrop-blur backdrop-filter shadow-2xl ring-1 ring-black ring-opacity-5 transition-all",
                            onChange: onHandleChange,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SearchIcon */.W1M, {
                                            className: "pointer-events-none absolute top-3.5 left-5 h-6 w-6 text-neutral-400",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Combobox.Input */.hQ.Input, {
                                            className: "h-12 w-full border-0 bg-transparent pl-16 pr-4 text-white rounded-xl placeholder-neutral-400 focus:ring-0 focus:outline-0",
                                            placeholder: "Search...",
                                            onChange: function(event) {
                                                return setSearch(event.target.value);
                                            },
                                            value: search
                                        })
                                    ]
                                }),
                                data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Combobox.Options */.hQ.Options, {
                                    static: true,
                                    className: "max-h-72 scroll-py-2 overflow-y-auto py-2 text-gray-100",
                                    children: data.map(function(person) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(headlessui_esm/* Combobox.Option */.hQ.Option, {
                                            value: person,
                                            className: function(param) {
                                                var active = param.active;
                                                return (0,clsx_m/* default */.Z)("select-none px-4 py-1 flex gap-4 items-center cursor-pointer", active && "bg-neutral-800 text-white");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                                    src: person.profileImg + "?w=128",
                                                    variant: avatar/* Avatar.variant.Circle */.q.variant.Circle,
                                                    size: avatar/* Avatar.size.XS */.q.size.XS,
                                                    fallbackText: "".concat(person.givenName[0], " ").concat(person.familyName[0])
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: person.fullName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-xs opacity-60 block",
                                                            children: person.teamName || "Onboarding"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, person.id);
                                    })
                                }),
                                search !== "" && data.length === 0 && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "p-4 text-sm text-gray-100",
                                    children: "No people found."
                                }),
                                search !== "" && data.length === 0 && isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "p-4 text-sm text-gray-100",
                                    children: "Loading..."
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/navigation/side-navigation.container.js
var side_navigation_container = __webpack_require__(92927);
// EXTERNAL MODULE: ./components/page.js
var page = __webpack_require__(44775);
// EXTERNAL MODULE: ./lib/identify.js
var identify = __webpack_require__(2823);
// EXTERNAL MODULE: ./lib/renderSegmentSnippet.js
var renderSegmentSnippet = __webpack_require__(35453);
// EXTERNAL MODULE: ./state-containers/experiment.js
var experiment = __webpack_require__(30784);
// EXTERNAL MODULE: ./lib/constants.js
var constants = __webpack_require__(52979);
// EXTERNAL MODULE: ./components/modals/app-locked-prompt.js
var app_locked_prompt = __webpack_require__(15745);
// EXTERNAL MODULE: ./components/modals/container.js
var container = __webpack_require__(56442);
// EXTERNAL MODULE: ./components/modals/desktop-qr-modal.js + 1 modules
var desktop_qr_modal = __webpack_require__(48333);
// EXTERNAL MODULE: ./components/navigation/side-navigation.js
var side_navigation = __webpack_require__(93405);
// EXTERNAL MODULE: ./components/workout/misc.js
var misc = __webpack_require__(25858);
;// CONCATENATED MODULE: ./components/AppLayout.js
























var ModalWrapper = function() {
    var deepLink = (0,misc/* useHandleClickCTA */.V)().deepLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_qr_modal/* DesktopQRModal */.B, {
        deepLink: deepLink
    });
};
var AppIdentifyComponent = /*#__PURE__*/ react.memo(function() {
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)().currentUser;
    (0,react.useEffect)(function() {
        if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) return;
        var id = currentUser.id, email = currentUser.email, givenName = currentUser.givenName, familyName = currentUser.familyName, membershipStatus = currentUser.membershipStatus;
        (0,identify/* identify */.y)({
            userId: id,
            email: email,
            givenName: givenName,
            familyName: familyName,
            membershipStatus: membershipStatus
        });
    }, [
        currentUser
    ]);
    return null;
});
var AppLayout = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head/* HeadContent */.Q, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppIdentifyComponent, {}),
             true ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "segment",
                dangerouslySetInnerHTML: {
                    __html: (0,renderSegmentSnippet/* renderSegmentSnippet */.w)("Z9YHBx8gveoU21ul7ARvQK9WfE4TIrte")
                }
            }) : 0,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hot_toast_esm/* Toaster */.x7, {
                position: "top-center",
                toastOptions: {
                    // Define default options
                    className: "",
                    duration: 5000,
                    background: "#333",
                    color: "#fff"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(experiment/* ExperimentProvider */.I, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_navigation_container/* SideNavigationProvider */.q, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(containers_search/* MemberSearchProvider */.b, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* ModalsProvider */.$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(app_locked_prompt/* AppLockedPrompt */.r, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPopover, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(side_navigation/* SideNavigation */.Hy, {
                                    showAuth: constants/* FEATURE_FLAGS.AUTH */.y8.AUTH
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(page/* Page */.T, {
                                    children: children
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full xl:px-16",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var components_AppLayout = (AppLayout);


/***/ }),

/***/ 11304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Avatar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-avatar/dist/index.module.js
var index_module = __webpack_require__(16235);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/index.esm.js
var index_esm = __webpack_require__(95774);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/styles.css
var styles = __webpack_require__(86422);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/icons/StreakIcon.js




function StreakIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 28 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.838 21.326c0 .562.439.988 1.043.988h7.96l-4.186 11.24c-.563 1.495.988 2.291 1.976 1.084l12.818-15.865c.247-.316.37-.604.37-.92 0-.576-.438-.988-1.042-.988h-7.96l4.186-11.254c.562-1.496-.988-2.292-1.977-1.07L4.222 20.406c-.247.302-.384.59-.384.92z",
            fill: "currentColor"
        })
    }));
}

// EXTERNAL MODULE: ./lib/constants.js
var constants = __webpack_require__(52979);
// EXTERNAL MODULE: ./lib/misc.js
var misc = __webpack_require__(8016);
;// CONCATENATED MODULE: ./components/avatar/index.tsx



/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable react/display-name */ 







var Variant;
(function(Variant) {
    Variant[Variant["Circle"] = 0] = "Circle";
    Variant[Variant["Rounded"] = 1] = "Rounded";
})(Variant || (Variant = {}));
var Size;
(function(Size) {
    Size[Size["XS"] = 0] = "XS";
    Size[Size["Small"] = 1] = "Small";
    Size[Size["Medium"] = 2] = "Medium";
    Size[Size["Large"] = 3] = "Large";
    Size[Size["XL"] = 4] = "XL";
})(Size || (Size = {}));
var getFallbackImg = function() {
    var no = randomIntFromInterval(0, DEMO_FALLBACK_PORTRAITS.length - 1);
    return DEMO_FALLBACK_PORTRAITS[no];
};
var ProgressRing = function(param) {
    var progress = param.progress, size = param.size, styles = param.styles;
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("absolute", (_obj = {}, (0,_define_property/* default */.Z)(_obj, Size.XS, "-m-2"), (0,_define_property/* default */.Z)(_obj, Size.Small, "-m-2"), (0,_define_property/* default */.Z)(_obj, Size.Medium, "-m-2 lg:-m-4"), (0,_define_property/* default */.Z)(_obj, Size.Large, "-m-3"), (0,_define_property/* default */.Z)(_obj, Size.XL, "-m-3 lg:-m-4"), _obj)[size]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CircularProgressbar */.Ip, {
            strokeWidth: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, Size.XS, 6), (0,_define_property/* default */.Z)(_obj1, Size.Small, 6), (0,_define_property/* default */.Z)(_obj1, Size.Medium, 4), (0,_define_property/* default */.Z)(_obj1, Size.Large, 4), (0,_define_property/* default */.Z)(_obj1, Size.XL, 4), _obj1)[size],
            styles: (0,index_esm/* buildStyles */.y3)((0,_object_spread/* default */.Z)({
                pathColor: "rgba(231, 255, 1, 1)",
                trailColor: "#0E0E0E"
            }, styles)),
            value: progress
        })
    });
};
var Avatar = /*#__PURE__*/ react.memo(function(param) {
    var src = param.src, size = param.size, variant = param.variant, isOnline = param.isOnline, _fallbackText = param.fallbackText, fallbackText = _fallbackText === void 0 ? "Aa" : _fallbackText, _className = param.className, className = _className === void 0 ? "" : _className, progress = param.progress, streakCount = param.streakCount, latestCheer = param.latestCheer, style = param.style;
    var imgSrc = src;
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
            "data-size": size,
            style: style,
            className: classnames_default()("relative inline-flex", (_obj = {}, (0,_define_property/* default */.Z)(_obj, Size.XL, "w-32 h-32 md:h-48 md:w-48"), (0,_define_property/* default */.Z)(_obj, Size.Large, "w-[5rem] h-[5rem] md:h-32 md:w-32"), (0,_define_property/* default */.Z)(_obj, Size.Medium, "h-[4.5rem] w-[4.5rem]"), (0,_define_property/* default */.Z)(_obj, Size.Small, "h-10 w-10 lg:h-16 lg:w-16"), (0,_define_property/* default */.Z)(_obj, Size.XS, "h-8 w-8"), _obj)[size], className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Image */.Ee, {
                    src: imgSrc,
                    alt: "Avatar",
                    className: classnames_default()("h-full w-full object-cover border shadow border-neutral-200/20", (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, Variant.Circle, "rounded-full"), (0,_define_property/* default */.Z)(_obj1, Variant.Rounded, "rounded"), _obj1)[variant])
                }),
                isOnline && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("absolute bottom-0 right-0 h-4 w-4", (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, Variant.Circle, "-translate-x-1/2 -translate-y-1/2"), (0,_define_property/* default */.Z)(_obj2, Variant.Rounded, ""), _obj2)[variant]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "block h-2.5 w-2.5 rounded-full bg-volt shadow-sm"
                    })
                }),
                typeof progress === "number" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressRing, {
                            size: size,
                            progress: 100,
                            styles: {
                                pathColor: "rgb(61 61 61)",
                                trailColor: "#0E0E0E"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressRing, {
                            size: size,
                            progress: progress,
                            styles: {
                                pathColor: "rgba(231, 255, 1, 1)",
                                trailColor: "transparent"
                            }
                        })
                    ]
                }) : null,
                streakCount || latestCheer ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("absolute bottom-0 right-0 flex center space-x-0 p-1 font-medium", "flex", (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, Size.XL, "lg:-translate-x-2 lg:-translate-y-4 text-black  text-sm"), (0,_define_property/* default */.Z)(_obj3, Size.Large, "lg:-translate-x-2 lg:-translate-y-4 text-black  text-sm"), (0,_define_property/* default */.Z)(_obj3, Size.Medium, "translate-x-2 translate-y-4 text-[0.75rem] text-volt "), (0,_define_property/* default */.Z)(_obj3, Size.Small, "translate-x-2 translate-y-4 text-[0.75rem] text-volt "), (0,_define_property/* default */.Z)(_obj3, Size.XS, "translate-x-2 translate-y-4 text-[0.5rem] text-volt "), _obj3)[size]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("absolute inset-0 border-black transform -skew-x-6", "flex", (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, Size.XL, "bg-volt border-4 rounded-lg text-sm"), (0,_define_property/* default */.Z)(_obj4, Size.Large, "bg-volt border-4 rounded-lg text-sm"), (0,_define_property/* default */.Z)(_obj4, Size.Medium, "text-[0.75rem] bg-neutral-800 border-2 rounded"), (0,_define_property/* default */.Z)(_obj4, Size.Small, "text-[0.75rem] bg-neutral-800 border-2 rounded"), (0,_define_property/* default */.Z)(_obj4, Size.XS, "text-[0.5rem] bg-neutral-800 border-2 rounded"), _obj4)[size])
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex center px-1 py-[0.15rem]",
                                children: latestCheer ? latestCheer : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: streakCount
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StreakIcon, {
                                            className: (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, Size.XL, "w-4 h-4"), (0,_define_property/* default */.Z)(_obj5, Size.Large, ""), (0,_define_property/* default */.Z)(_obj5, Size.XS, "w-3 h-3"), _obj5)[size]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Fallback */.NY, {
                    className: classnames_default()("flex h-full w-full items-center justify-center bg-neutral-700 shadow border border-neutral-600", (_obj6 = {}, (0,_define_property/* default */.Z)(_obj6, Variant.Circle, "rounded-full"), (0,_define_property/* default */.Z)(_obj6, Variant.Rounded, "rounded"), _obj6)[variant], (_obj7 = {}, (0,_define_property/* default */.Z)(_obj7, Size.XL, "text-2xl"), (0,_define_property/* default */.Z)(_obj7, Size.Large, "text-xl"), (0,_define_property/* default */.Z)(_obj7, Size.Medium, "text-default"), (0,_define_property/* default */.Z)(_obj7, Size.Small, "text-sm"), (0,_define_property/* default */.Z)(_obj7, Size.XS, "text-xs"), _obj7)[size]),
                    delayMs: 600,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-medium text-neutral-400",
                        children: fallbackText
                    })
                })
            ]
        })
    });
});
// @ts-ignore
Avatar.variant = Variant;
// @ts-ignore
Avatar.size = Size;


/***/ }),

/***/ 19789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ MemberSearchProvider; },
/* harmony export */   "c": function() { return /* binding */ useMemberSearchContainer; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var unstated_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88305);
/* harmony import */ var _hooks_use_member_search__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71215);




var useContainer = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), nodes = ref[0], setNodes = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), filters = ref1[0], setFilters = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), search = ref3[0], setSearch = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(50), limit = ref4[0], setLimit = ref4[1];
    var ref5 = (0,_hooks_use_member_search__WEBPACK_IMPORTED_MODULE_2__/* .useMemberSearch */ .s)({
        limit: limit,
        nodes: nodes,
        filters: filters,
        search: search
    }), data = ref5.data, isLoading = ref5.isLoading;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            setNodes({});
            setFilters({});
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!open) {
            setTimeout(function() {
                setNodes({});
                setFilters({});
                setLimit(50);
            }, 250);
        }
    }, [
        open
    ]);
    return {
        limit: limit,
        setLimit: setLimit,
        nodes: nodes,
        setNodes: setNodes,
        filters: filters,
        setFilters: setFilters,
        open: open,
        setOpen: setOpen,
        search: search,
        setSearch: setSearch,
        data: data,
        isLoading: isLoading
    };
};
var ref = (0,unstated_next__WEBPACK_IMPORTED_MODULE_3__/* .createContainer */ .f)(useContainer), useMemberSearchContainer = ref.useContainer, MemberSearchProvider = ref.Provider;



/***/ }),

/***/ 71215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ useMemberSearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useDebounce.js
var useDebounce = __webpack_require__(1601);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./node_modules/json-to-graphql-query/lib/index.js
var lib = __webpack_require__(43450);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./hooks/useCurrentUser.js
var useCurrentUser = __webpack_require__(73038);
;// CONCATENATED MODULE: ./hooks/useDetailedUsers.js







var endpoint = "https://rocky-api.prod.ltdev.io/graphql";
var memberRequestKeys = {
    email: true,
    createdTS: true,
    profileImgImgixURL: true,
    gender: true,
    dob: true,
    roleName: true,
    membershipStatus: true,
    lastActivityTS: true,
    trialExpirationTS: true,
    tags: true,
    note: true,
    isPushEnabled: true,
    coachRoomID: true,
    coachRoomLastMessageSentTS: true,
    coachRoomLastCoachMessageRecievedTS: true,
    coachRoomLastImpersonatedCoachMessageRecievedTS: true,
    teamRoomID: true,
    teamRoomLastMessageSentTS: true,
    activeRoomFlagTypes: true,
    avgWorkoutRating: true,
    numWorkoutsCompleted: true,
    numWorkoutsCompleted7Days: true,
    numWorkoutsCompleted14Days: true,
    numWorkoutsCompleted30Days: true,
    numWorkoutsIncomplete: true,
    lastCompletedWorkoutID: true,
    lastCompletedWorkoutWorkoutID: true,
    lastCompletedWorkoutCreatedTS: true,
    lastCompletedWorkoutCompletedTS: true,
    lastCompletedWorkoutCompletionNumber: true,
    lastCompletedWorkoutRating: true,
    teamID: true,
    numTeamJoins: true,
    utmSource: true,
    utmContent: true,
    utmCampaign: true,
    utmMedium: true,
    utmTerm: true,
    utmType: true,
    subscriptionStripeCustomerID: true,
    subscriptionStatus: true,
    subscriptionType: true,
    healthStatus: true,
    // subscriptionRenewalTS: true,
    subscriptionIsCancelingAtPeriodEnd: true,
    subscriptionCurrentPeriodEndTS: true,
    subscriptionCurrentPeriodStartTS: true,
    introTrialPeriodStartTS: true,
    introTrialPeriodEndTS: true,
    latestTrialPeriodStartTS: true,
    latestTrialPeriodEndTS: true,
    latestTrialPeriodReason: true,
    // subscriptionOfferingID: true,
    // subscriptionOfferingName: true,
    // subscriptionOfferingDurMonths: true,
    // latestPaidPeriodStartedTS: true,
    // latestPaidPeriodEndedTS: true,
    // latestPaidPeriodNumCompleted30Days: true,
    recommendedTeamIDs: true,
    allFlagsAreMuted: true,
    recentTeamHistory: {
        teamID: true,
        teamName: true,
        joinedTS: true
    },
    flagSettings: {
        flagType: true
    }
};
function useDetailedUsers() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, node = ref.node, filter = ref.filter, _sort = ref.sort, sort = _sort === void 0 ? [] : _sort, active = ref.active, _first = ref.first, first = _first === void 0 ? 25 : _first, props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var ref1 = (0,useCurrentUser/* useCurrentUser */.x)(), session = ref1.session, currentUser = ref1.currentUser;
    return (0,es.useInfiniteQuery)(active ? [
        "detailedUsers"
    ].concat((0,_to_consumable_array/* default */.Z)(props)) : null, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var tmp, after;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tmp = param.pageParam, after = tmp === void 0 ? "" : tmp;
                        _ctx.next = 3;
                        return (0,dist.request)((currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && endpoint, (0,lib.jsonToGraphQLQuery)({
                            query: {
                                detailedUsers: {
                                    __args: {
                                        first: first,
                                        after: after,
                                        filter: filter,
                                        sort: sort
                                    },
                                    totalCount: true,
                                    pageInfo: {
                                        hasPreviousPage: true,
                                        hasNextPage: true,
                                        startCursor: true,
                                        endCursor: true
                                    },
                                    debug: {
                                        sqlText: true
                                    },
                                    edges: {
                                        cursor: true,
                                        node: node
                                    }
                                }
                            }
                        }, {
                            pretty: true
                        }), {}, {
                            Authorization: "Bearer ".concat(session),
                            "Content-Type": "application/json"
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage) {
            var ref, ref1, ref2, ref3;
            if (!(lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.detailedUsers) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.length)) return;
            if (!(lastPage === null || lastPage === void 0 ? void 0 : (ref2 = lastPage.detailedUsers) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.hasNextPage)) return;
            var cursor = lastPage.detailedUsers.edges[lastPage.detailedUsers.edges.length - 1].cursor;
            return cursor;
        }
    });
}

// EXTERNAL MODULE: ./hooks/useTeams.js
var useTeams = __webpack_require__(99986);
;// CONCATENATED MODULE: ./components/member/hooks/use-member-search.js










var useMemberSearch = function(param) {
    var _nodes = param.nodes, nodes = _nodes === void 0 ? {} : _nodes, _filters = param.filters, filters = _filters === void 0 ? {} : _filters, _search = param.search, search = _search === void 0 ? "" : _search, _limit = param.limit, limit = _limit === void 0 ? 50 : _limit;
    var isAdmin = (0,useCurrentUser/* useCurrentUser */.x)().isAdmin;
    var debouncedInputValue = (0,useDebounce/* useDebounce */.N)(search, 200);
    var ref = (0,_sliced_to_array/* default */.Z)(debouncedInputValue.split(" "), 2), tmp = ref[0], $givenName = tmp === void 0 ? "" : tmp, tmp1 = ref[1], $familyName = tmp1 === void 0 ? "" : tmp1;
    var getTeamById = (0,useTeams/* useTeams */.y2)().getTeamById;
    var filter = (0,react.useMemo)(function() {
        var res = {};
        if (!$familyName) {
            res.or = [
                {
                    givenName: {
                        like: $givenName
                    }
                },
                {
                    familyName: {
                        like: $familyName || $givenName
                    }
                }, 
            ];
        } else {
            res.and = [
                {
                    givenName: {
                        like: $givenName
                    }
                },
                {
                    familyName: {
                        like: $familyName || $givenName
                    }
                }, 
            ];
        }
        return (0,_object_spread/* default */.Z)({}, res, filters);
    }, [
        $givenName,
        $familyName,
        filters
    ]);
    var _ref = useDetailedUsers({
        active: isAdmin,
        first: limit,
        filter: filter,
        node: (0,_object_spread/* default */.Z)({
            id: true,
            createdAt: {
                __aliasFor: "createdTS"
            },
            profileImg: {
                __aliasFor: "profileImgImgixURL"
            },
            teamID: true,
            givenName: true,
            familyName: true
        }, nodes)
    }, [
        filter,
        nodes,
        limit,
        isAdmin
    ]), status = _ref.status, response = _ref.data, error = _ref.error, isFetching = _ref.isFetching, isLoading = _ref.isLoading, hasNextPage = _ref.hasNextPage, fetchNextPage = _ref.fetchNextPage, more = (0,_object_without_properties/* default */.Z)(_ref, [
        "status",
        "data",
        "error",
        "isFetching",
        "isLoading",
        "hasNextPage",
        "fetchNextPage"
    ]);
    var data = (0,react.useMemo)(function() {
        return (0,lodash.flatten)(response === null || response === void 0 ? void 0 : response.pages.map(function(data) {
            var ref;
            return ((data === null || data === void 0 ? void 0 : (ref = data.detailedUsers) === null || ref === void 0 ? void 0 : ref.edges) || []).map(function(n) {
                var ref, ref1, ref2, ref3;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, n === null || n === void 0 ? void 0 : n.node), {
                    teamName: (ref1 = getTeamById(n === null || n === void 0 ? void 0 : (ref = n.node) === null || ref === void 0 ? void 0 : ref.teamID)) === null || ref1 === void 0 ? void 0 : ref1.name,
                    fullName: "".concat((n === null || n === void 0 ? void 0 : (ref2 = n.node) === null || ref2 === void 0 ? void 0 : ref2.givenName) || "", " ").concat((n === null || n === void 0 ? void 0 : (ref3 = n.node) === null || ref3 === void 0 ? void 0 : ref3.familyName) || ""),
                    cursor: n.cursor
                });
            }).filter(function(param) {
                var givenName = param.givenName;
                return !!givenName;
            });
        }));
    }, [
        response,
        getTeamById
    ]);
    return {
        hasNextPage: hasNextPage,
        fetchNextPage: fetchNextPage,
        isFetching: isFetching,
        isLoading: isLoading,
        data: data
    };
};


/***/ }),

/***/ 15745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ AppLockedPrompt; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56727);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _workout_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25858);
/* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56442);






var Content = function(param) {
    var launchProgramID = param.launchProgramID, _CTALabel = param.CTALabel, CTALabel = _CTALabel === void 0 ? "Get The App" : _CTALabel;
    var ref = (0,_container__WEBPACK_IMPORTED_MODULE_3__/* .useModals */ .o)(), title = ref.title, description = ref.description, handleClose = ref.handleClose;
    var handleClickCta = (0,_workout_misc__WEBPACK_IMPORTED_MODULE_2__/* .useHandleClickCTA */ .V)(launchProgramID, CTALabel).handleClickCta;
    var handleClick = function() {
        handleClose();
        setTimeout(function() {
            return handleClickCta();
        }, 250);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-auto flex items-center justify-center p-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "p-2",
                            src: "/assets/logo/white.svg",
                            alt: "Ladder Logo",
                            width: 632 * 0.2,
                            height: 104 * 0.2
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-3 text-center sm:mt-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Dialog.Title */ .Vq.Title, {
                                as: "h3",
                                className: "text-2xl uppercase leading-tight font-display font-medium text-white/90",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-400",
                                    children: description
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "block mx-auto cta justify-center rounded-full border border-transparent shadow-sm px-8 py-2 bg-volt text-base font-medium text-black focus:outline-none focus:ring-2 sm:col-start-2",
                    onClick: handleClick,
                    children: CTALabel
                })
            })
        ]
    });
};
var AppLockedPrompt = function(props) {
    var ref = (0,_container__WEBPACK_IMPORTED_MODULE_3__/* .useModals */ .o)(), isOpen = ref.appLockedPromptOpen, setIsOpen = ref.setAppLockedPromptOpen;
    var cancelButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition.Root */ .uT.Root, {
        show: isOpen,
        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Dialog */ .Vq, {
            as: "div",
            style: {
                zIndex: 100
            },
            className: "fixed inset-0 overflow-y-auto",
            initialFocus: cancelButtonRef,
            onClose: setIsOpen,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition.Child */ .uT.Child, {
                        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Dialog.Overlay */ .Vq.Overlay, {
                            className: "fixed inset-0 bg-white/50 backdrop-blur-sm transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "​"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition.Child */ .uT.Child, {
                        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative inline-block align-bottom bg-dark-slanted-gradient border border-space-200 rounded-xl px-4 pt-5 pb-6 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 sm:pb-12",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props))
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 56442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ModalsProvider; },
/* harmony export */   "o": function() { return /* binding */ useModals; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89211);
/* harmony import */ var unstated_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88305);




var initialTitle = "This feature is available exclusively on the Ladder iPhone app";
var initialDescription = "Discover a workout plan for every day that's easy to follow, can be done from anywhere, and is new each week.";
var useContainer = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), appLockedPromptOpen = ref[0], setAppLockedPromptOpen = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(false), 2), showQRModal = ref1[0], toggleShowQRModal = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialTitle), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialDescription), description = ref3[0], setDescription = ref3[1];
    var handleClose = function() {
        setAppLockedPromptOpen(false);
        setTitle(initialTitle);
        setDescription(initialDescription);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!appLockedPromptOpen) {
            setTimeout(function() {
                setTitle(initialTitle);
                setDescription(initialDescription);
            }, 500);
        }
    }, [
        appLockedPromptOpen
    ]);
    return {
        showQRModal: showQRModal,
        toggleShowQRModal: toggleShowQRModal,
        appLockedPromptOpen: appLockedPromptOpen,
        setAppLockedPromptOpen: setAppLockedPromptOpen,
        title: title,
        setTitle: setTitle,
        description: description,
        setDescription: setDescription,
        handleClose: handleClose
    };
};
var ref = (0,unstated_next__WEBPACK_IMPORTED_MODULE_3__/* .createContainer */ .f)(useContainer), useModals = ref.useContainer, ModalsProvider = ref.Provider;



/***/ }),

/***/ 48333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ DesktopQRModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/qr-code/QRCode.js
var QRCode = __webpack_require__(43705);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./lib/misc.js
var misc = __webpack_require__(8016);
;// CONCATENATED MODULE: ./hooks/useUrlShortener.js




var getShortUrl = function(longUrl) {
    return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (longUrl) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 2:
                    _ctx.next = 4;
                    return (0,misc/* fetcher */._i)("/api/shorten-url", {
                        method: "POST",
                        body: JSON.stringify({
                            longUrl: longUrl
                        })
                    });
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var useUrlShortener = function(longUrl, initialData) {
    var ref = (0,es.useQuery)(longUrl && "/api/shorten-url/".concat(longUrl), getShortUrl(longUrl), {
        initialData: initialData
    }), data = ref.data, error = ref.error, isLoading = ref.isLoading;
    return {
        data: data,
        error: error,
        isLoading: isLoading
    };
};

// EXTERNAL MODULE: ./components/workout/misc.js
var workout_misc = __webpack_require__(25858);
// EXTERNAL MODULE: ./components/modals/container.js
var container = __webpack_require__(56442);
;// CONCATENATED MODULE: ./components/modals/desktop-qr-modal.js







var DesktopQRModal = function(param) {
    var launchProgramID = param.launchProgramID, _title = param.title, title = _title === void 0 ? "GET THE LADDER APP" : _title, _description = param.description, description = _description === void 0 ? "Scan to download the Ladder iOS app!" : _description;
    var ref;
    var cancelButtonRef = (0,react.useRef)(null);
    var ref1 = (0,container/* useModals */.o)(), showQRModal = ref1.showQRModal, toggleShowQRModal = ref1.toggleShowQRModal;
    var deepLink = (0,workout_misc/* useHandleClickCTA */.V)(launchProgramID, "GET THE APP").deepLink;
    var ref2 = useUrlShortener(deepLink), data = ref2.data, error = ref2.error, isLoading = ref2.isLoading;
    var shortUrl = data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Root */.uT.Root, {
        show: showQRModal,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Dialog */.Vq, {
            as: "div",
            style: {
                zIndex: 100
            },
            className: "fixed inset-0 overflow-y-auto",
            initialFocus: cancelButtonRef,
            onClose: toggleShowQRModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "items-center justify-center hidden min-h-screen px-4 pt-4 pb-20 text-center sm:flex sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Dialog.Overlay */.Vq.Overlay, {
                            className: "fixed inset-0 transition-opacity bg-white/50 backdrop-blur-sm"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "​"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative inline-block px-4 pt-5 pb-6 overflow-hidden text-left align-bottom transition-all transform border shadow-xl bg-dark-slanted-gradient border-space-200 rounded-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:pt-6 sm:px-12 sm:pb-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "py-6 mb-2 text-4xl tracking-wide text-center text-white uppercase 2xl:text-5xl font-display",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center justify-center p-6 mx-auto transition-transform duration-150 ease-in-out bg-white border border-black shadow-2xl rounded-3xl",
                                    style: {
                                        width: 330,
                                        height: 330
                                    },
                                    children: error ? "Something went wrong. Please refresh and try again." : shortUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCode/* QRCode */.s, {
                                        size: 280,
                                        logoSize: 0,
                                        value: shortUrl
                                    }) : "Loading..."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pt-3 pb-3 space-x-2 text-xl font-bold text-center 2xl:text-2xl text-lemon",
                                    children: description
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 53231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ navigationItems; }
});

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(63801);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/icons/ConnectIcon.js




function ConnectIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.782 15.19c4.087 0 7.47-3.384 7.47-7.47 0-4.08-3.39-7.471-7.478-7.471-4.08 0-7.463 3.39-7.463 7.47 0 4.087 3.391 7.47 7.47 7.47zM2.896 9.147L5.438 5.86c.161-.19.315-.278.483-.278.132 0 .271.05.418.131L9.62 7.47l2.52-1.355c.446-.241.85.198.534.608l-2.556 3.303c-.154.198-.322.279-.49.279a.893.893 0 01-.41-.132l-3.29-1.758L3.432 9.77c-.432.234-.879-.168-.535-.623z",
            fill: "currentColor"
        })
    }));
}

;// CONCATENATED MODULE: ./components/icons/HomeIcon.js




function HomeIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M.868 7.635c0 .3.234.586.63.586.205 0 .373-.11.527-.234l7.331-6.153c.162-.146.36-.146.52 0l7.332 6.153c.147.124.315.234.52.234.344 0 .623-.212.623-.564a.599.599 0 00-.227-.498l-2.051-1.728V2.5c0-.322-.205-.527-.528-.527h-.783c-.315 0-.528.205-.528.527v1.384L10.5.75C9.957.29 9.283.29 8.734.75L1.102 7.16a.613.613 0 00-.234.475zm2.285 6.534c0 1.018.615 1.618 1.648 1.618h9.631c1.033 0 1.64-.6 1.64-1.619v-5.8l-6.02-5.047c-.278-.234-.608-.227-.879 0l-6.02 5.047v5.8zm8.342.439h-3.78V9.767c0-.337.228-.557.565-.557h2.659c.336 0 .556.22.556.557v4.84z",
            fill: "currentColor"
        })
    }));
}

;// CONCATENATED MODULE: ./components/icons/TeamsIcon.js




function TeamsIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.716 6.947a3.21 3.21 0 003.194-3.194c0-1.75-1.443-3.186-3.194-3.186a3.2 3.2 0 00-3.193 3.186 3.206 3.206 0 003.193 3.194zM3.4 12.44a3.21 3.21 0 003.193-3.193C6.592 7.503 5.15 6.06 3.4 6.06A3.2 3.2 0 00.206 9.247a3.2 3.2 0 003.193 3.193zm10.65 0c1.742 0 3.185-1.443 3.185-3.193 0-1.744-1.443-3.186-3.186-3.186-1.765 0-3.2 1.442-3.2 3.186a3.207 3.207 0 003.2 3.193zm-5.333 5.493a3.21 3.21 0 003.194-3.193c0-1.743-1.443-3.186-3.194-3.186a3.204 3.204 0 00-3.193 3.186 3.206 3.206 0 003.193 3.193z",
            fill: "currentColor"
        })
    }));
}

;// CONCATENATED MODULE: ./components/navigation/constants.js




var navigationItems = [
    {
        name: "Home",
        href: "/app",
        icon: HomeIcon,
        current: function(pathname) {
            return pathname === "/app";
        },
        eventDetails: {
            category: "General Navigation",
            action: "Home Viewed"
        }
    },
    {
        name: "Connect",
        href: "#",
        unavailable: true,
        icon: ConnectIcon,
        current: function() {
            return null;
        },
        eventDetails: {
            category: "General Navigation",
            action: "Community Opened"
        }
    },
    {
        name: "Teams",
        href: "/app/teams",
        icon: TeamsIcon,
        current: function(pathname) {
            return pathname === "/app/teams" || pathname === "/app/team/[slug]";
        },
        eventDetails: {
            category: "General Navigation",
            action: "Choose Team Viewed"
        }
    },
    {
        name: "Profile",
        href: "/app/me",
        authenticated: true,
        icon: esm/* UserCircleIcon */.lMe,
        current: function(pathname) {
            return pathname === "/app/member/[memberId]";
        },
        eventDetails: {
            category: "General Navigation",
            action: "Profile Viewed"
        }
    }, 
];


/***/ }),

/***/ 92927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useSideNavigation; },
/* harmony export */   "q": function() { return /* binding */ SideNavigationProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11042);
/* harmony import */ var unstated_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88305);
/* harmony import */ var _hooks_listeners__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90403);






var useContainer = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), sidebarMinimized = ref[0], setSidebarMinimized = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), sidebarOpen = ref1[0], setSidebarOpen = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleRouteChange = function() {
            return setSidebarOpen(false);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events,
        router
    ]);
    (0,react_use__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        if (false) {}
        if (window.innerWidth >= 1164) return;
        setSidebarMinimized(true);
    }, []);
    (0,_hooks_listeners__WEBPACK_IMPORTED_MODULE_2__/* .useWindowEventListener */ .Fm)("resize", function(e) {
        if (e.target.innerWidth >= 1164) return;
        setSidebarMinimized(true);
    }, []);
    return {
        sidebarOpen: sidebarOpen,
        setSidebarOpen: setSidebarOpen,
        sidebarMinimized: sidebarMinimized,
        setSidebarMinimized: setSidebarMinimized
    };
};
var ref = (0,unstated_next__WEBPACK_IMPORTED_MODULE_5__/* .createContainer */ .f)(useContainer), useSideNavigation = ref.useContainer, SideNavigationProvider = ref.Provider;



/***/ }),

/***/ 93405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hy": function() { return /* binding */ SideNavigation; },
/* harmony export */   "Lg": function() { return /* binding */ EliteCard; },
/* harmony export */   "ke": function() { return /* binding */ SideNavigationDesktop; }
/* harmony export */ });
/* unused harmony export SideNavigationContent */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(56727);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63153);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62469);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(86010);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72986);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21190);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _components_footer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23333);
/* harmony import */ var _hooks_listeners__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90403);
/* harmony import */ var _hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73038);
/* harmony import */ var _lib_captureEvent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75507);
/* harmony import */ var _modals_container__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56442);
/* harmony import */ var _nav__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44401);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53231);
/* harmony import */ var _side_navigation_container__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92927);




















var EliteCard = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex overflow-hidden flex-col text-neutral-300 mt-auto flex-shrink-0 p-4 bg-neutral-800 rounded-lg my-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-[1]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "text-base lg:text-xl mb-2",
                        children: [
                            "Upgrade your account to ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                className: "text-white",
                                children: "Elite+"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-sm lg:text-base",
                        children: "Get unlimited access to all Ladder Teams and save workouts."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/assets/elite-plus-card.png",
                className: "w-[60%] lg:w-full scale-150 transform translate-x-16 lg:translate-x-8 -translate-y-4 lg:-translate-y-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-base lg:text-xl text-volt font-bold",
                        children: "Get Elite+"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-black bg-volt rounded-full p-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRightIcon */ .LZ3, {
                            className: "w-5 h-5"
                        })
                    })
                ]
            })
        ]
    });
};
var SideNavigationContent = function(param) {
    var showAuth = param.showAuth, showUpgradeCard = param.showUpgradeCard, showLogo = param.showLogo, activeTeamID = param.activeTeamID, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter;
    var _ref = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), pathname = _ref.pathname, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_ref, [
        "pathname"
    ]);
    var setAppLockedPromptOpen = (0,_modals_container__WEBPACK_IMPORTED_MODULE_11__/* .useModals */ .o)().setAppLockedPromptOpen;
    var sidebarMinimized = (0,_side_navigation_container__WEBPACK_IMPORTED_MODULE_14__/* .useSideNavigation */ .c)().sidebarMinimized;
    var currentUser = (0,_hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_9__/* .useCurrentUser */ .x)().currentUser;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 pb-4 overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex py-[1.15rem] lg:hidden items-center flex-shrink-0 px-4 border-b border-neutral-800",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                            href: "/app",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nav__WEBPACK_IMPORTED_MODULE_12__/* .Logo */ .T, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                        "aria-label": "Sidebar",
                        className: "mt-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "px-2 space-y-1",
                                children: [
                                    _constants__WEBPACK_IMPORTED_MODULE_13__/* .navigationItems.map */ .T.map(function(item) {
                                        var current = item.current(pathname);
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: item.href,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_16__/* .motion.a */ .E.a, {
                                                onClick: function(e) {
                                                    (0,_lib_captureEvent__WEBPACK_IMPORTED_MODULE_10__/* .captureEvent */ .e)(item.eventDetails);
                                                    if (item.unavailable || item.authenticated && !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) {
                                                        e.preventDefault();
                                                        setAppLockedPromptOpen(true);
                                                    }
                                                },
                                                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("hover:bg-neutral-700 hover:text-white group cursor-pointer flex space-x-4 items-center px-2 py-2 border-2 text-base font-medium rounded-md", {
                                                    "lg:justify-center": sidebarMinimized,
                                                    "mx-auto": !sidebarMinimized,
                                                    "text-white border-transparent": current,
                                                    "border-transparent text-gray-400": !current
                                                }),
                                                "aria-current": current ? "page" : "",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("h-6 w-6 text-inherit"),
                                                        "aria-hidden": "true"
                                                    }),
                                                    !sidebarMinimized ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "lg:flex hidden",
                                                        children: item.name
                                                    }) : null,
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "lg:hidden flex",
                                                        children: item.name
                                                    })
                                                ]
                                            })
                                        }, item.name);
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                        className: "border-neutral-700"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_16__/* .motion.a */ .E.a, {
                                        onClick: function(e) {
                                            (0,_lib_captureEvent__WEBPACK_IMPORTED_MODULE_10__/* .captureEvent */ .e)({
                                                category: "General Navigation",
                                                action: "Feedback Clicked"
                                            });
                                        },
                                        href: "https://airtable.com/shr6wdtvTqExmKmRE",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("hover:bg-neutral-700 border-transparent text-gray-400 hover:text-white group cursor-pointer flex space-x-4 items-center px-2 py-2 border-2 text-base font-medium rounded-md", {
                                            "lg:justify-center": sidebarMinimized,
                                            "mx-auto": !sidebarMinimized
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ClipboardIcon */ .Kmg, {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("h-6 w-6 text-inherit"),
                                                "aria-hidden": "true"
                                            }),
                                            !sidebarMinimized ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "lg:flex hidden",
                                                children: "BETA Feedback"
                                            }) : null,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "lg:hidden flex",
                                                children: "BETA Feedback"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && showUpgradeCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_16__/* .motion.div */ .E.div, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .AnimatePresence */ .M, {
                                        exitBeforeEnter: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_16__/* .motion.div */ .E.div, {
                                            transition: {
                                                duration: 0.1
                                            },
                                            initial: {
                                                opacity: 0
                                            },
                                            animate: {
                                                x: 0,
                                                opacity: 1
                                            },
                                            exit: {
                                                opacity: 0
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                                "hidden lg:block p-2 min-w-[207px]": !sidebarMinimized,
                                                "px-2 py-4 center hidden lg:flex": sidebarMinimized
                                            }),
                                            children: sidebarMinimized ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .LightningBoltIcon */ .YGl, {
                                                className: "w-6 h-6 text-lemon"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EliteCard, {})
                                        }, sidebarMinimized ? "LightningBoltIcon" : "EliteCard")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_16__/* .motion.div */ .E.div, {
                                        className: "block lg:hidden p-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EliteCard, {})
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: showFooter && !sidebarMinimized ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-start mb-4 space-x-4 px-4 transition-opacity opacity-80 hover:opacity-100",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_7__/* .SocialItem */ .n, {
                            url: "tiktok.com/@joinladder",
                            imageName: "tiktok",
                            invert: true,
                            showName: false
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_7__/* .SocialItem */ .n, {
                            url: "instagram.com/joinladder",
                            imageName: "instagram",
                            showName: false
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_7__/* .SocialItem */ .n, {
                            url: "facebook.com/joinladder",
                            imageName: "facebook",
                            showName: false
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_7__/* .SocialItem */ .n, {
                            url: "support@joinladder.com",
                            urlPrefix: "mailto:",
                            imageName: "mail",
                            showName: false
                        })
                    ]
                }) : null
            })
        ]
    });
};
var useIsomorphicEffect =  false ? 0 : react__WEBPACK_IMPORTED_MODULE_6__.useLayoutEffect;
var topNavOffsetHeight = function() {
    var ref;
    return ((ref = document.getElementById("top-navigation")) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
};
var SideNavigationDesktop = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), sideNavTop = ref[0], setSideNavTop = ref[1];
    useIsomorphicEffect(function() {
        setTimeout(function() {
            return setSideNavTop(topNavOffsetHeight);
        }, 500);
    }, []);
    (0,_hooks_listeners__WEBPACK_IMPORTED_MODULE_8__/* .useWindowEventListener */ .Fm)("resize", function() {
        return setSideNavTop(topNavOffsetHeight);
    }, []);
    var sidebarMinimized = (0,_side_navigation_container__WEBPACK_IMPORTED_MODULE_14__/* .useSideNavigation */ .c)().sidebarMinimized;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "hidden lg:flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_16__/* .motion.div */ .E.div, {
            style: {
                top: sideNavTop,
                height: "calc(100vh - ".concat(sideNavTop, "px)")
            },
            animate: {
                width: !sidebarMinimized ? 241 : 70,
                display: "flex"
            },
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("sticky hidden lg:flex inset-y-0 bg-neutral-900 border-r border-neutral-800 w-full flex-col justify-between max-w-[14rem]", {
                "min-w-[241px]": !sidebarMinimized,
                "min-w-[70px]": sidebarMinimized
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SideNavigationContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, props))
        })
    });
};
var SideNavigation = function(param) {
    var showAuth = param.showAuth;
    var ref = (0,_side_navigation_container__WEBPACK_IMPORTED_MODULE_14__/* .useSideNavigation */ .c)(), sidebarOpen = ref.sidebarOpen, setSidebarOpen = ref.setSidebarOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_20__/* .Transition.Root */ .uT.Root, {
        show: sidebarOpen,
        as: react__WEBPACK_IMPORTED_MODULE_6__.Fragment,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_20__/* .Dialog */ .Vq, {
            as: "div",
            className: "fixed inset-0 z-50 flex lg:hidden",
            onClose: setSidebarOpen,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_20__/* .Transition.Child */ .uT.Child, {
                    as: react__WEBPACK_IMPORTED_MODULE_6__.Fragment,
                    enter: "transition-opacity ease-linear duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "transition-opacity ease-linear duration-300",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_20__/* .Dialog.Overlay */ .Vq.Overlay, {
                        className: "fixed inset-0 bg-opacity-75 bg-neutral-600 backdrop-blur-sm"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_20__/* .Transition.Child */ .uT.Child, {
                    as: react__WEBPACK_IMPORTED_MODULE_6__.Fragment,
                    enter: "transition ease-in-out duration-300 transform",
                    enterFrom: "-translate-x-full",
                    enterTo: "translate-x-0",
                    leave: "transition ease-in-out duration-300 transform",
                    leaveFrom: "translate-x-0",
                    leaveTo: "-translate-x-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_16__/* .motion.div */ .E.div, {
                        layout: true,
                        className: "relative flex flex-col flex-1 w-full max-w-xs bg-neutral-900 focus:outline-none",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_20__/* .Transition.Child */ .uT.Child, {
                                as: react__WEBPACK_IMPORTED_MODULE_6__.Fragment,
                                enter: "ease-in-out duration-300",
                                enterFrom: "opacity-0",
                                enterTo: "opacity-100",
                                leave: "ease-in-out duration-300",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "fixed top-0 right-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        type: "button",
                                        className: "flex items-center justify-center w-10 h-10 ml-1 rounded-full focus:outline-none",
                                        onClick: function() {
                                            return setSidebarOpen(false);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "sr-only",
                                                children: "Close sidebar"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* .XIcon */ .b0D, {
                                                className: "w-6 h-6 text-white",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SideNavigationContent, {
                                showAuth: showAuth
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex-shrink-0 w-14",
                    "aria-hidden": "true"
                })
            ]
        })
    });
};


/***/ }),

/***/ 43705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ QRCode; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_qr_code__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1653);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var QRCode = function(param) {
    var _value = param.value, value = _value === void 0 ? "QR Code" : _value, size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_qr_code__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        value: value,
        size: size
    });
};


/***/ }),

/***/ 25858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useHandleClickCTA; }
/* harmony export */ });
/* harmony import */ var _lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93335);
/* harmony import */ var _modals_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56442);
/* harmony import */ var _lib_captureEvent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75507);
/* harmony import */ var _lib_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8016);




var useHandleClickCTA = function(launchProgramID) {
    var CTALabel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "SEE MORE WORKOUTS";
    var isDesktop = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .useIsDesktop */ .Ce)();
    var toggleShowQRModal = (0,_modals_container__WEBPACK_IMPORTED_MODULE_1__/* .useModals */ .o)().toggleShowQRModal;
    var baseUrl = new URL("https://ladder.page.link?ibi=com.ladder.bootcamp&isi=1502936453&ius=ladderteams");
    var baseDeepLink = new URL("https://joinladder.com".concat(launchProgramID ? "?launchProgramID=".concat(launchProgramID) : ""));
    var link = (0,_lib_misc__WEBPACK_IMPORTED_MODULE_3__/* .updateUTMParams */ .m2)(baseDeepLink, "_appdirect");
    var deepLink = new URL(baseUrl);
    deepLink.searchParams.set("link", link);
    var href = isDesktop ? (0,_lib_misc__WEBPACK_IMPORTED_MODULE_3__/* .updateUTMParams */ .m2)("https://offers.joinladder.com/survey", "_homepagesurvey") : deepLink;
    var handleClickCta = function() {
        var ref;
        (0,_lib_captureEvent__WEBPACK_IMPORTED_MODULE_2__/* .captureEvent */ .e)({
            category: "workout",
            action: "workout_cta_clicked",
            label: CTALabel,
            value: isDesktop ? "Show QR Modal" : href === null || href === void 0 ? void 0 : (ref = href.toString) === null || ref === void 0 ? void 0 : ref.call(href)
        });
        if (isDesktop) {
            toggleShowQRModal(true);
        } else {
            window.open(href, "_blank");
        }
    };
    return {
        handleClickCta: handleClickCta,
        deepLink: deepLink,
        href: href
    };
};


/***/ }),

/***/ 90403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fm": function() { return /* binding */ useWindowEventListener; },
/* harmony export */   "qX": function() { return /* binding */ useEscapeKey; },
/* harmony export */   "wp": function() { return /* binding */ useKeyUp; }
/* harmony export */ });
/* unused harmony exports useEventListener, useKeyDown, useMouseDown, useHeldKey */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useEventListener = function() {
    var event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", action = arguments.length > 1 ? arguments[1] : void 0, props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], bubble = arguments.length > 3 ? arguments[3] : void 0;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (false) {}
        document.addEventListener(event, action, bubble);
        return function() {
            return document.removeEventListener(event, action, bubble);
        };
    }, props);
};
var useWindowEventListener = function() {
    var event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", action = arguments.length > 1 ? arguments[1] : void 0, props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (false) {}
        window.addEventListener(event, action);
        return function() {
            return window.removeEventListener(event, action);
        };
    }, props);
};
var useKeyUp = function(keyCode, action, props) {
    useEventListener("keyup", function(e) {
        return e.keyCode === keyCode && action(e, props);
    }, props);
};
var useKeyDown = function(keyCode, action, props) {
    useEventListener("keydown", function(e) {
        return e.keyCode === keyCode && action(e, props);
    }, props);
};
var useEscapeKey = function(action) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    useKeyUp(27, action, props);
};
var useMouseDown = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ref = useState(false), mouseDown = ref[0], setMouseDown = ref[1];
    var timeout;
    var handleAction = function() {
        return setMouseDown(true);
    };
    var handleMouseDown = function() {
        timeout = setTimeout(handleAction, 250);
    };
    var handleMouseUp = function() {
        clearTimeout(timeout);
        setMouseDown(false);
    };
    useEventListener("mousedown", handleMouseDown, _to_consumable_array(props).concat([
        mouseDown,
        setMouseDown, 
    ]));
    useEventListener("mouseup", handleMouseUp, _to_consumable_array(props).concat([
        mouseDown,
        setMouseDown, 
    ]));
    return mouseDown;
};
var useHeldKey = function(keyCode) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var ref = useState(false), isHeldDown = ref[0], setIsHeldDown = ref[1];
    var timeout;
    var handleAction = function() {
        // if (document?.activeElement?.nodeName === "INPUT") return;
        setIsHeldDown(true);
    };
    var handleKeyDown = function() {
        return handleAction();
    };
    var handleKeyUp = function() {
        clearTimeout(timeout);
        setIsHeldDown(false);
    };
    useKeyDown(keyCode, handleKeyDown, _to_consumable_array(props).concat([
        timeout,
        isHeldDown,
        setIsHeldDown, 
    ]));
    useKeyUp(keyCode, handleKeyUp, _to_consumable_array(props).concat([
        timeout,
        isHeldDown,
        setIsHeldDown, 
    ]));
    useEffect(function() {
        window.addEventListener("blur", handleKeyUp);
        return function() {
            return window.removeEventListener("blur", handleKeyUp);
        };
    }, _to_consumable_array(props).concat([
        isHeldDown,
        setIsHeldDown,
        timeout
    ]));
    useEffect(function() {
        return function() {
            return timeout && clearTimeout(timeout);
        };
    }, []);
    return isHeldDown;
};


/***/ }),

/***/ 73038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useCurrentUser; }
/* harmony export */ });
/* unused harmony export getCurrentUser */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);
/* harmony import */ var _lib_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8016);
/* harmony import */ var _state_containers_session__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36132);






var getCurrentUser = function(session) {
    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (session) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return (0,_lib_misc__WEBPACK_IMPORTED_MODULE_3__/* .fetcher */ ._i)("https://rocky-api.prod.ltdev.io" + "/users/me", {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(session)
                        }
                    });
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var useCurrentUser = function(initialData) {
    var session = (0,_state_containers_session__WEBPACK_IMPORTED_MODULE_4__/* .useSession */ .kP)().session;
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)("/users/me", getCurrentUser(session), {
        initialData: initialData
    }), currentUser = ref.data, error = ref.error, isLoading = ref.isLoading, refetch = ref.refetch;
    var isAdmin = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === "admin";
    }, [
        currentUser
    ]);
    var isCoach = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === "coach";
    }, [
        currentUser
    ]);
    return {
        session: session,
        currentUser: currentUser,
        isAdmin: isAdmin,
        isCoach: isCoach,
        error: error,
        refetch: refetch,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 1601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay, key) {
    // State and setters for debounced value
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    var handler;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Update debounced value after delay
        handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay,
        key
    ] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}


/***/ })

}]);